var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerefied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20C36 22.375 34.5 24.375 32.375 25.1875C33.3125 27.1875 32.9375 29.6875 31.3125 31.3125C29.625 33 27.1875 33.375 25.125 32.4375C24.3125 34.5625 22.3125 36 20 36C17.625 36 15.625 34.5625 14.8125 32.4375C12.8125 33.375 10.3125 33 8.6875 31.3125C7 29.6875 6.625 27.1875 7.5625 25.1875C5.4375 24.375 4 22.375 4 20C4 17.6875 5.4375 15.6875 7.5625 14.875C6.625 12.875 7 10.375 8.6875 8.6875C10.3125 7.0625 12.8125 6.6875 14.8125 7.625C15.625 5.5 17.625 4 20 4C22.3125 4 24.3125 5.5 25.125 7.625C27.125 6.6875 29.625 7.0625 31.3125 8.6875C32.9375 10.375 33.3125 12.875 32.375 14.875C34.5 15.6875 36 17.6875 36 20ZM26.9375 17.25C27.1875 17 27.1875 16.5625 26.9375 16.3125L25.3125 14.6875C25.0625 14.375 24.625 14.375 24.3125 14.6875L18.25 20.6875L15.625 18.0625C15.375 17.75 14.9375 17.75 14.625 18L13 19.625C12.75 19.9375 12.75 20.375 13 20.625L17.75 25.375C18 25.625 18.4375 25.6875 18.75 25.375L26.9375 17.25Z",
    fill: "url(#paint0_linear_918_28306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_918_28306",
    x1: 6.18947,
    y1: 11.1579,
    x2: 21.1838,
    y2: 36.7679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerefied);
export default __webpack_public_path__ + "static/media/Verefied.7ab44476af26b754c74a10d4822f6a03.svg";
export { ForwardRef as ReactComponent };